import { render, staticRenderFns } from "./SetupIntegration.vue?vue&type=template&id=045b7f80&"
import script from "./SetupIntegration.vue?vue&type=script&lang=js&"
export * from "./SetupIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports